"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    viewBox: "0 0 30 19",
    width: props.size || props.width || "24px",
    id: "master",
    height: props.size || props.height || "24px"
  }, props), /*#__PURE__*/_react["default"].createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M11.591 9.795a9.18 9.18 0 013.41-7.146A9.158 9.158 0 009.203.591a9.205 9.205 0 000 18.409A9.158 9.158 0 0015 16.942a9.18 9.18 0 01-3.409-7.147",
    fill: "#E71513"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M20.796.59A9.158 9.158 0 0015 2.65a9.18 9.18 0 013.409 7.146c0 2.887-1.33 5.46-3.41 7.148A9.163 9.163 0 0020.797 19a9.205 9.205 0 000-18.41",
    fill: "#ED9027"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M18.409 9.795a9.18 9.18 0 00-3.41-7.146 9.18 9.18 0 00-3.408 7.146A9.18 9.18 0 0015 16.942a9.18 9.18 0 003.409-7.147",
    fill: "#FE4E18"
  })));
};
var _default = exports["default"] = SvgComponent;